import $ from 'jquery';

class BackToTop {
    constructor() {
        this.body = $("html, body");
        this.document = $(document);
        this.backToTopBtn = $('#back-to-top');

        $(window).resize(this.scrollHandler.bind(this));
        this.document.on('scroll', this.scrollHandler.bind(this));
        this.document.ready(this.scrollHandler.bind(this));


        // Button Events
        this.backToTopBtn.click(() => {
            this.body.stop().animate({scrollTop: 0}, 500, 'swing');
        });

        this.scrollHandler.bind(this);
    }

    scrollHandler() {
        if (this.document.width() < 786) {
            if (this.document.scrollTop() > 100) {
                this.backToTopBtn.show();
            } else {
                this.backToTopBtn.hide();
            }
        }
        else {
            this.backToTopBtn.hide();
        }
    }
}

export default BackToTop;